import React from "react"
import { Flex, Box, Heading, Image } from "@chakra-ui/react"

import { GatsbyImage } from "gatsby-plugin-image"

import MethodologyContent from "./methodology-content"
import sectionData from "../../../../static/data/all_stars_page.json"
import { useYear } from "../../../context/YearContext"

const styles = {
  root: {
    width: "100%",
    px: { base: "16px", md: "24px", lg: "24px" },
    fontFamily: "Inter var, sans-serif",
  },
  "inner-box": {
    marginX: "auto",
    my: { base: "20px", md: "20px", lg: "60px" },
    maxWidth: "812px",
  },
  "top-section": {
    flexDirection: "column",
    alignItems: "center",
  },
  heading: {
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px",
    textAlign: "center",
    letterSpacing: "0em",
  },
  "allstar-text": {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#129459",
  },
  hero: {
    mt: { base: "16px", md: "16px", lg: "24px" },
  },
}

const SectionBody = ({ data: graphQLData, location }) => {
  const { selectedYear } = useYear()
  const badges = graphQLData?.allBadges?.edges || []

  const badgeImageName = sectionData[selectedYear]?.sectionHero?.image

  const badgeItem = badges?.find(item => item.node.name === badgeImageName)
  return (
    <Box sx={styles.root}>
      <Box sx={styles["inner-box"]}>
        <Flex sx={styles["top-section"]}>
          <Heading as="h2" sx={styles["allstar-text"]}>
            Healthcare Research All-Stars
          </Heading>
          <Heading as="h2" sx={styles.heading} mt="8px">
            Research Methodology
          </Heading>
          <Box sx={styles.hero} mb="40px">
            <Image
              as={GatsbyImage}
              alt={"Healthcare Research All-Stars Logo"}
              image={badgeItem?.node?.childImageSharp?.gatsbyImageData}
              w="213px"
            />
          </Box>
        </Flex>
        <MethodologyContent location={location} />
      </Box>
    </Box>
  )
}

export default SectionBody
